import { useState, useEffect } from 'react';
import { supabase } from './supabase';

function WalletHistorySection({ userId }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.from('wallet_history').select('*').eq('user_id', userId).order('analyzed_at', { ascending: false }).limit(20)
      .then(({ data }) => { setHistory(data || []); setLoading(false); });
  }, [userId]);

  if (loading) return null;
  if (history.length === 0) return null;

  return (
    <div style={{padding:'14px',background:'#0d1117',border:'1px solid #1a2030',borderRadius:10}}>
      <div style={{fontSize:11,fontWeight:700,color:'#c0c8d8',marginBottom:10}}> Wallets/Tokens analysés ({history.length})</div>
      {history.map((h,i)=>(
        <div key={i} style={{padding:'7px 10px',background:'#090c12',border:'1px solid #1a2030',borderRadius:6,marginBottom:6,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
          <div style={{fontSize:10,color:'#5a6a80',fontFamily:'monospace',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',flex:1}}>{h.wallet_address}</div>
          <div style={{fontSize:9,color:'#3a4a5a',flexShrink:0,marginLeft:8}}>{new Date(h.analyzed_at).toLocaleDateString('fr-FR')}</div>
          <a href={`https://solscan.io/token/${h.wallet_address}`} target="_blank"rel="noreferrer"style={{fontSize:9,color:'#00e5cc',marginLeft:8,textDecoration:'none',flexShrink:0}}>↗</a>
        </div>
      ))}
    </div>
  );
}

function UserDetailView({ u, onClose, onUpdate, onImpersonate }) {
  const [trades, setTrades] = useState([]);
  const [configs, setConfigs] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [simInput, setSimInput] = useState('');
  const [planInput, setPlanInput] = useState(u.plan || 'free');
  const [durationInput, setDurationInput] = useState('30');
  const [msg, setMsg] = useState('');

  useEffect(() => { fetchUserData(); }, []);

  const fetchUserData = async () => {
    setLoadingData(true);
    const [tradesRes, configsRes] = await Promise.all([
      supabase.from('trades').select('*').eq('user_id', u.id).order('created_at', { ascending: false }).limit(20),
      supabase.from('configs').select('*').eq('user_id', u.id),
    ]);
    setTrades(tradesRes.data || []);
    setConfigs(configsRes.data || []);
    setLoadingData(false);
  };

  const updateSimBalance = async () => {
    const bal = parseFloat(simInput);
    if (isNaN(bal) || bal <= 0) return setMsg('Montant invalide');
    await supabase.from('profiles').update({ sim_balance: bal }).eq('id', u.id);
    setMsg('Solde sim mis à jour !');
    setTimeout(() => setMsg(''), 3000);
    onUpdate();
  };

  const renewPlan = async () => {
    const days = parseInt(durationInput) || 30;
    const now = new Date();
    const expires = new Date(now.getTime() + days * 24 * 60 * 60 * 1000);
    await supabase.from('profiles').update({
      plan: planInput,
      plan_expires_at: planInput === 'lifetime'? null : expires.toISOString(),
      plan_started_at: now.toISOString(),
    }).eq('id', u.id);
    setMsg('Plan mis à jour !');
    setTimeout(() => setMsg(''), 3000);
    onUpdate();
  };

  const simTrades = trades.filter(t => t.is_sim);
  const liveTrades = trades.filter(t => !t.is_sim);
  const totalPnl = trades.reduce((s, t) => s + (t.pnl_usd || 0), 0);
  const winRate = trades.length > 0 ? Math.round(trades.filter(t => t.pnl_usd > 0).length / trades.length * 100) : 0;

  const getPlanColor = (plan) => {
    const colors = { free:'#5a6a80', basic:'#00e5cc', pro:'#7c4dff', vip:'#f0a500', lifetime:'#ff6b6b'};
    return colors[plan] || '#5a6a80';
  };

  const daysLeft = u.plan_expires_at ? Math.ceil((new Date(u.plan_expires_at) - new Date()) / (1000 * 60 * 60 * 24)) : null;

  return (
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.95)',backdropFilter:'blur(8px)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:10000}}>
      <div style={{background:'#0b0e14',border:'1px solid rgba(0,229,204,0.3)',borderRadius:12,width:720,maxHeight:'90vh',display:'flex',flexDirection:'column'}}>

        <div style={{padding:'16px 20px',borderBottom:'1px solid #1a2030',display:'flex',alignItems:'center',justifyContent:'space-between',flexShrink:0}}>
          <div style={{display:'flex',alignItems:'center',gap:12}}>
            <button onClick={onClose} style={{background:'none',border:'none',color:'#5a6a80',cursor:'pointer',fontSize:18}}>←</button>
            <div style={{width:36,height:36,borderRadius:'50%',background:'linear-gradient(135deg,#00e5cc,#7c4dff)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:14,fontWeight:800,color:'#060809'}}>
              {u.email?.charAt(0).toUpperCase()}
            </div>
            <div>
              <div style={{fontSize:13,fontWeight:700,color:'#e0e8f0'}}>{u.email}</div>
              <div style={{display:'flex',gap:6,marginTop:2}}>
                <span style={{fontSize:9,padding:'1px 6px',borderRadius:4,background:'rgba(0,229,204,0.1)',color:'#00e5cc',border:'1px solid #00e5cc22',fontWeight:700}}>
                  {u.approved?'✅ Approuvé':'🟡 En attente'}
                </span>
                {u.plan && <span style={{fontSize:9,padding:'1px 6px',borderRadius:4,background:'rgba(124,77,255,0.1)',color:getPlanColor(u.plan),border:`1px solid ${getPlanColor(u.plan)}22`,fontWeight:700,textTransform:'uppercase'}}>{u.plan}</span>}
                {daysLeft !== null && <span style={{fontSize:9,padding:'1px 6px',borderRadius:4,background:'rgba(90,106,128,0.1)',color:'#5a6a80',border:'1px solid #5a6a8022',fontWeight:700}}>{daysLeft}j restants</span>}
              </div>
            </div>
          </div>
          {/*  Boutons header */}
          <div style={{display:'flex',alignItems:'center',gap:8}}>
            {onImpersonate && !u.is_admin && (
              <button onClick={()=>{ onImpersonate(u); onClose(); }}
                style={{padding:'5px 12px',borderRadius:6,background:'rgba(240,165,0,0.15)',border:'1px solid #f0a50033',color:'#f0a500',fontSize:11,fontWeight:700,cursor:'pointer'}}>
                👁 Voir son interface
              </button>
            )}
            <button onClick={onClose} style={{background:'none',border:'none',color:'#5a6a80',cursor:'pointer',fontSize:20}}>×</button>
          </div>
        </div>

        {msg && <div style={{padding:'8px 20px',background:'rgba(0,229,204,0.08)',fontSize:12,color:'#00e5cc',textAlign:'center'}}>{msg}</div>}

        <div style={{flex:1,overflowY:'auto',padding:'16px 20px',display:'flex',flexDirection:'column',gap:16}}>

          {/* Stats rapides */}
          <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:10}}>
            {[
              {label:'Solde SIM', value:`${u.sim_balance || 0} SOL`, color:'#7c4dff'},
              {label:'Trades total', value:trades.length, color:'#00e5cc'},
              {label:'PNL total', value:`${totalPnl >= 0 ? '+': ''}${totalPnl.toFixed(2)}$`, color:totalPnl >= 0 ? '#00e5cc': '#ff6b6b'},
              {label:'Win rate', value:`${winRate}%`, color:winRate >= 50 ? '#00e5cc': '#ff6b6b'},
            ].map((s,i) => (
              <div key={i} style={{padding:'12px',background:'#0d1117',border:'1px solid #1a2030',borderRadius:8,textAlign:'center'}}>
                <div style={{fontSize:10,color:'#3a4a5a',marginBottom:4}}>{s.label}</div>
                <div style={{fontSize:16,fontWeight:800,color:s.color,fontFamily:'monospace'}}>{s.value}</div>
              </div>
            ))}
          </div>

          {/* Gestion solde sim */}
          <div style={{padding:'14px',background:'rgba(124,77,255,0.04)',border:'1px solid #7c4dff22',borderRadius:10}}>
            <div style={{fontSize:11,fontWeight:700,color:'#7c4dff',marginBottom:10}}> Modifier le solde sim</div>
            <div style={{display:'flex',gap:6,marginBottom:8,flexWrap:'wrap'}}>
              {['10','50','100','500','1000'].map(v=>(
                <button key={v} onClick={()=>setSimInput(v)}
                  style={{padding:'4px 10px',borderRadius:4,background:simInput===v?'rgba(124,77,255,0.2)':'#0d1117',border:`1px solid ${simInput===v?'#7c4dff44':'#1a2030'}`,color:simInput===v?'#7c4dff':'#5a6a80',fontSize:10,fontWeight:700,cursor:'pointer'}}>
                  {v} SOL
                </button>
              ))}
            </div>
            <div style={{display:'flex',gap:8}}>
              <input type="number"placeholder="Montant personnalisé..."value={simInput} onChange={e=>setSimInput(e.target.value)}
                style={{flex:1,background:'#0d1117',border:'1px solid #1a2030',borderRadius:6,color:'#c0c8d8',fontSize:11,padding:'7px 10px',outline:'none'}}/>
              <button onClick={updateSimBalance}
                style={{padding:'7px 14px',borderRadius:6,background:'rgba(124,77,255,0.15)',border:'1px solid #7c4dff33',color:'#7c4dff',fontSize:11,fontWeight:700,cursor:'pointer'}}>
                Définir
              </button>
            </div>
          </div>

          {/* Gestion plan */}
          <div style={{padding:'14px',background:'rgba(0,229,204,0.04)',border:'1px solid #00e5cc11',borderRadius:10}}>
            <div style={{fontSize:11,fontWeight:700,color:'#00e5cc',marginBottom:10}}> Gérer l'abonnement</div>
            <div style={{display:'flex',gap:6,marginBottom:8,flexWrap:'wrap'}}>
              {['free','basic','pro','vip','lifetime'].map(p=>(
                <button key={p} onClick={()=>setPlanInput(p)}
                  style={{padding:'4px 10px',borderRadius:4,background:planInput===p?'rgba(0,229,204,0.15)':'#0d1117',border:`1px solid ${planInput===p?'#00e5cc44':'#1a2030'}`,color:planInput===p?'#00e5cc':'#5a6a80',fontSize:10,fontWeight:700,cursor:'pointer',textTransform:'uppercase'}}>
                  {p}
                </button>
              ))}
            </div>
            {planInput !== 'lifetime'&& (
              <div style={{display:'flex',gap:6,marginBottom:8,flexWrap:'wrap'}}>
                {[['7','7j'],['30','1 mois'],['90','3 mois'],['180','6 mois'],['365','1 an']].map(([v,l])=>(
                  <button key={v} onClick={()=>setDurationInput(v)}
                    style={{padding:'4px 10px',borderRadius:4,background:durationInput===v?'rgba(0,229,204,0.15)':'#0d1117',border:`1px solid ${durationInput===v?'#00e5cc44':'#1a2030'}`,color:durationInput===v?'#00e5cc':'#5a6a80',fontSize:10,fontWeight:700,cursor:'pointer'}}>
                    {l}
                  </button>
                ))}
              </div>
            )}
            <button onClick={renewPlan}
              style={{padding:'8px 16px',borderRadius:6,background:'rgba(0,229,204,0.15)',border:'1px solid #00e5cc33',color:'#00e5cc',fontSize:11,fontWeight:700,cursor:'pointer'}}>
               Mettre à jour le plan
            </button>
          </div>

          {/* Configs copytrade */}
          <div style={{padding:'14px',background:'#0d1117',border:'1px solid #1a2030',borderRadius:10}}>
            <div style={{fontSize:11,fontWeight:700,color:'#c0c8d8',marginBottom:10}}> Configs Copytrade ({configs.length})</div>
            {loadingData ? <div style={{fontSize:11,color:'#3a4a5a'}}>Chargement...</div> :
            configs.length === 0 ? <div style={{fontSize:11,color:'#3a4a5a'}}>Aucune config</div> :
            configs.map(c=>(
              <div key={c.id} style={{padding:'8px 10px',background:'#090c12',border:'1px solid #1a2030',borderRadius:6,marginBottom:6,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                <div>
                  <div style={{fontSize:11,fontWeight:700,color:'#c0c8d8'}}>{c.emoji} {c.name}</div>
                  <div style={{fontSize:9,color:'#3a4a5a',fontFamily:'monospace',marginTop:2}}>{c.target_wallet?.slice(0,12)}...</div>
                </div>
                <span style={{fontSize:9,padding:'2px 8px',borderRadius:4,background:c.enabled?'rgba(0,229,204,0.1)':'rgba(90,106,128,0.1)',color:c.enabled?'#00e5cc':'#5a6a80',border:`1px solid ${c.enabled?'#00e5cc22':'#5a6a8022'}`,fontWeight:700}}>
                  {c.enabled?'ACTIF':'INACTIF'}
                </span>
              </div>
            ))}
          </div>

          {/* Trades récents */}
          <div style={{padding:'14px',background:'#0d1117',border:'1px solid #1a2030',borderRadius:10}}>
            <div style={{fontSize:11,fontWeight:700,color:'#c0c8d8',marginBottom:10}}>
               Trades récents ({liveTrades.length} live · {simTrades.length} sim)
            </div>
            {loadingData ? <div style={{fontSize:11,color:'#3a4a5a'}}>Chargement...</div> :
            trades.length === 0 ? <div style={{fontSize:11,color:'#3a4a5a'}}>Aucun trade</div> :
            trades.slice(0,10).map(t=>(
              <div key={t.id} style={{padding:'8px 10px',background:'#090c12',border:'1px solid #1a2030',borderRadius:6,marginBottom:6,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                <div>
                  <div style={{display:'flex',alignItems:'center',gap:6}}>
                    <span style={{fontSize:11,fontWeight:700,color:'#c0c8d8'}}>{t.symbol||'—'}</span>
                    <span style={{fontSize:9,padding:'1px 5px',borderRadius:3,background:t.is_sim?'rgba(124,77,255,0.1)':'rgba(0,229,204,0.1)',color:t.is_sim?'#7c4dff':'#00e5cc',border:`1px solid ${t.is_sim?'#7c4dff22':'#00e5cc22'}`,fontWeight:700}}>
                      {t.is_sim?'SIM':'LIVE'}
                    </span>
                  </div>
                  <div style={{fontSize:9,color:'#3a4a5a',marginTop:2}}>{t.created_at?new Date(t.created_at).toLocaleDateString('fr-FR'):''}</div>
                </div>
                <div style={{textAlign:'right'}}>
                  <div style={{fontSize:11,fontWeight:700,color:t.pnl_usd>=0?'#00e5cc':'#ff6b6b'}}>{t.pnl_usd>=0?'+':''}{(t.pnl_usd||0).toFixed(2)}$</div>
                  <div style={{fontSize:9,color:'#3a4a5a'}}>{t.roi>=0?'+':''}{(t.roi||0).toFixed(1)}%</div>
                </div>
              </div>
            ))}
          </div>

          {/* Wallets bot */}
          {u.bot_wallets && u.bot_wallets.length > 0 && (
            <div style={{padding:'14px',background:'#0d1117',border:'1px solid #1a2030',borderRadius:10}}>
              <div style={{fontSize:11,fontWeight:700,color:'#c0c8d8',marginBottom:10}}> Wallets Bot</div>
              {u.bot_wallets.map((w,i)=>(
                <div key={i} style={{padding:'8px 10px',background:'#090c12',border:'1px solid #1a2030',borderRadius:6,marginBottom:6}}>
                  <div style={{fontSize:10,color:'#5a6a80',fontFamily:'monospace'}}>{w.address}</div>
                </div>
              ))}
            </div>
          )}

          <WalletHistorySection userId={u.id} />
        </div>
      </div>
    </div>
  );
}

export default function AdminPanel({ user, onClose, onImpersonate }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('pending');
  const [selectedUser, setSelectedUser] = useState(null);
  const [viewUser, setViewUser] = useState(null);
  const [simInput, setSimInput] = useState('');
  const [planInput, setPlanInput] = useState('free');
  const [durationInput, setDurationInput] = useState('30');
  const [actionMsg, setActionMsg] = useState('');
  const [newApiKey, setNewApiKey] = useState('');
  const [apiMsg, setApiMsg] = useState('');
  const [showApiSection, setShowApiSection] = useState(false);
  const [tradesMsg, setTradesMsg] = useState('');
  const [showTradesSection, setShowTradesSection] = useState(false);
  const [confirmClear, setConfirmClear] = useState('');
  const [newAdminPwd, setNewAdminPwd] = useState('');
  const [confirmAdminPwd, setConfirmAdminPwd] = useState('');
  const [adminPwdMsg, setAdminPwdMsg] = useState('');

  const changeAdminPassword = async () => {
    if (!newAdminPwd || newAdminPwd.length < 8) { setAdminPwdMsg('❌ Minimum 8 caractères'); return; }
    if (newAdminPwd !== confirmAdminPwd) { setAdminPwdMsg('❌ Les mots de passe ne correspondent pas'); return; }
    const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(newAdminPwd));
    const hash = Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2,'0')).join('');
    await supabase.from('settings').upsert({ key: 'admin-password-hash', value: hash, updated_at: new Date().toISOString() }, { onConflict: 'key' });
    setAdminPwdMsg('✅ Mot de passe admin mis à jour !');
    setNewAdminPwd(''); setConfirmAdminPwd('');
    setTimeout(() => setAdminPwdMsg(''), 3000);
  };

  const currentApiKey = localStorage.getItem('helius-api-key') || '';

  const saveApiKey = async () => {
    const key = newApiKey.trim();
    if (!key) { setApiMsg('❌ Clé vide'); setTimeout(()=>setApiMsg(''),3000); return; }
    if (key.length < 20) { setApiMsg('❌ Clé invalide'); setTimeout(()=>setApiMsg(''),3000); return; }
    localStorage.setItem('helius-api-key', key);
    await supabase.from('settings').upsert({ key: 'helius-api-key', value: key, updated_at: new Date().toISOString() }, { onConflict: 'key' });
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (session?.access_token) {
        await fetch('/api/update-helius-key', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ key, token: session.access_token }),
        });
      }
    } catch(e) {}
    setApiMsg('✅ Clé synchronisée partout (bot + API) !');
    setNewApiKey('');
  };

  const removeApiKey = async () => {
    localStorage.removeItem('helius-api-key');
    await supabase.from('settings').delete().eq('key', 'helius-api-key');
    setApiMsg('✅ Clé supprimée — utilisation de la clé par défaut.');
    setTimeout(()=>setApiMsg(''),3000);
  };

  const clearSimTrades = async (mode) => {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session?.user) return;
      let query = supabase.from('trades').delete().eq('user_id', session.user.id).eq('is_sim', true);
      if (mode === 'history') query = query.in('resultat', ['Gagnant', 'Perdant']);
      const { error } = await query;
      if (error) throw error;
      // Vider aussi le cache localStorage
      if (mode === 'all') {
        localStorage.removeItem('bot-trades');
      } else {
        const local = JSON.parse(localStorage.getItem('bot-trades') || '[]');
        const filtered = local.filter(t => !(t.isSim && (t.resultat === 'Gagnant' || t.resultat === 'Perdant')));
        localStorage.setItem('bot-trades', JSON.stringify(filtered));
      }
      setTradesMsg(mode === 'history' ? '✅ Historique SIM effacé !' : '✅ Toutes les positions SIM effacées !');
      setConfirmClear('');
      setTimeout(() => window.location.reload(), 1500);
    } catch(e) {
      setTradesMsg('❌ Erreur : ' + e.message);
      setTimeout(() => setTradesMsg(''), 3000);
    }
  };

  useEffect(() => { fetchUsers(); }, [filter]);

  const fetchUsers = async () => {
    setLoading(true);
    let query = supabase.from('profiles').select('*').order('created_at', { ascending: false });
    if (filter === 'pending') query = query.eq('pending', true).eq('approved', false);
    if (filter === 'approved') query = query.eq('approved', true);
    if (filter === 'expired') query = query.lt('plan_expires_at', new Date().toISOString()).eq('approved', true);
    const { data } = await query;
    setUsers(data || []);
    setLoading(false);
  };

  const approve = async (u) => {
    const sim = parseFloat(simInput) || 50;
    const days = parseInt(durationInput) || 30;
    const now = new Date();
    const expires = new Date(now.getTime() + days * 24 * 60 * 60 * 1000);
    await supabase.from('profiles').update({
      approved: true, pending: false,
      sim_balance: sim, plan: planInput,
      plan_started_at: now.toISOString(),
      plan_expires_at: planInput === 'lifetime'? null : expires.toISOString(),
    }).eq('id', u.id);
    setSelectedUser(null);
    setActionMsg('Utilisateur approuvé !');
    setTimeout(() => setActionMsg(''), 3000);
    fetchUsers();
  };

  const reject = async (userId) => {
    await supabase.from('profiles').update({ approved: false, pending: false }).eq('id', userId);
    fetchUsers();
  };

  const revoke = async (userId) => {
    await supabase.from('profiles').update({ approved: false }).eq('id', userId);
    fetchUsers();
  };

  const renew = async (u) => {
    const days = parseInt(durationInput) || 30;
    const now = new Date();
    const expires = new Date(now.getTime() + days * 24 * 60 * 60 * 1000);
    await supabase.from('profiles').update({
      plan: planInput,
      plan_expires_at: planInput === 'lifetime'? null : expires.toISOString(),
      plan_started_at: now.toISOString(),
    }).eq('id', u.id);
    setSelectedUser(null);
    setActionMsg('Abonnement renouvelé !');
    setTimeout(() => setActionMsg(''), 3000);
    fetchUsers();
  };

  const getPlanColor = (plan) => {
    const colors = { free:'#5a6a80', basic:'#00e5cc', pro:'#7c4dff', vip:'#f0a500', lifetime:'#ff6b6b'};
    return colors[plan] || '#5a6a80';
  };

  const isExpired = (u) => u.plan_expires_at && new Date(u.plan_expires_at) < new Date();
  const daysLeft = (u) => u.plan_expires_at ? Math.ceil((new Date(u.plan_expires_at) - new Date()) / (1000 * 60 * 60 * 24)) : null;
  const plans = ['free','basic','pro','vip','lifetime'];
  const durations = [['7','7 jours'],['30','1 mois'],['90','3 mois'],['180','6 mois'],['365','1 an']];

  if (viewUser) {
    return <UserDetailView u={viewUser} onClose={()=>setViewUser(null)} onUpdate={fetchUsers} onImpersonate={onImpersonate}/>;
  }

  return (
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.9)',backdropFilter:'blur(8px)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}}>
      <div style={{background:'#0b0e14',border:'1px solid rgba(0,229,204,0.3)',borderRadius:12,width:660,maxHeight:'85vh',display:'flex',flexDirection:'column'}}>

        <div style={{padding:'16px 20px',borderBottom:'1px solid #1a2030',display:'flex',alignItems:'center',justifyContent:'space-between',flexShrink:0}}>
          <div>
            <div style={{fontSize:16,fontWeight:800,color:'#00e5cc',fontFamily:'monospace'}}> PANEL ADMIN</div>
            <div style={{fontSize:11,color:'#3a4a5a',marginTop:2}}>Gestion des utilisateurs COPYCCXX</div>
          </div>
          <button onClick={onClose} style={{background:'none',border:'none',color:'#5a6a80',cursor:'pointer',fontSize:20}}>×</button>
        </div>

        {actionMsg && (
          <div style={{padding:'8px 20px',background:'rgba(0,229,204,0.08)',borderBottom:'1px solid #00e5cc22',fontSize:12,color:'#00e5cc',textAlign:'center'}}>
            {actionMsg}
          </div>
        )}

        {/* Section clé API Helius */}
        <div style={{padding:'10px 20px',borderBottom:'1px solid #1a2030',flexShrink:0,background:'#090c12'}}>
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',cursor:'pointer'}} onClick={()=>setShowApiSection(v=>!v)}>
            <div style={{display:'flex',alignItems:'center',gap:8}}>
              <span style={{fontSize:12}}>🔑</span>
              <span style={{fontSize:11,fontWeight:700,color:'#5a6a80',letterSpacing:'0.5px'}}>CLÉ API HELIUS</span>
              {currentApiKey
                ? <span style={{fontSize:9,padding:'1px 7px',borderRadius:4,background:'rgba(0,229,204,0.1)',color:'#00e5cc',border:'1px solid #00e5cc22',fontWeight:700}}>CUSTOM</span>
                : <span style={{fontSize:9,padding:'1px 7px',borderRadius:4,background:'rgba(90,106,128,0.1)',color:'#5a6a80',border:'1px solid #5a6a8022',fontWeight:700}}>PAR DÉFAUT</span>
              }
            </div>
            <span style={{fontSize:10,color:'#3a4a5a'}}>{showApiSection ? '▲' : '▼'}</span>
          </div>

          {showApiSection && (
            <div style={{marginTop:12}}>
              {currentApiKey && (
                <div style={{fontSize:10,color:'#5a6a80',marginBottom:8,fontFamily:'monospace',background:'#0d1117',border:'1px solid #1a2030',borderRadius:6,padding:'6px 10px',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                  <span>Active : <span style={{color:'#7c4dff'}}>{currentApiKey.slice(0,8)}...{currentApiKey.slice(-4)}</span></span>
                  <button onClick={removeApiKey} style={{background:'none',border:'none',color:'#ff6b6b',fontSize:10,cursor:'pointer',padding:0}}>Supprimer</button>
                </div>
              )}
              <div style={{display:'flex',gap:8}}>
                <input
                  value={newApiKey}
                  onChange={e=>setNewApiKey(e.target.value)}
                  placeholder="Colle ta nouvelle clé Helius ici..."
                  style={{flex:1,background:'#0d1117',border:'1px solid #1a2030',borderRadius:6,color:'#c0c8d8',fontSize:11,padding:'7px 10px',outline:'none',fontFamily:'monospace'}}
                />
                <button onClick={saveApiKey}
                  style={{padding:'7px 14px',borderRadius:6,background:'rgba(0,229,204,0.15)',border:'1px solid #00e5cc33',color:'#00e5cc',fontSize:11,fontWeight:700,cursor:'pointer',whiteSpace:'nowrap'}}>
                  Sauvegarder
                </button>
              </div>
              {apiMsg && (
                <div style={{fontSize:10,marginTop:6,color:apiMsg.startsWith('✅')?'#00e5cc':'#ff6b6b'}}>
                  {apiMsg}
                </div>
              )}
              <div style={{fontSize:9,color:'#3a4a5a',marginTop:6}}>
                Après avoir sauvegardé, rechargez la page pour appliquer la nouvelle clé.
              </div>
            </div>
          )}
        </div>

        {/* Section mot de passe admin */}
        <div style={{padding:'10px 20px',borderBottom:'1px solid #1a2030',flexShrink:0,background:'#090c12'}}>
          <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:10}}>
            <span style={{fontSize:12}}>🔒</span>
            <span style={{fontSize:11,fontWeight:700,color:'#5a6a80',letterSpacing:'0.5px'}}>MOT DE PASSE ADMIN</span>
          </div>
          <input type="password" placeholder="Nouveau mot de passe (min 8 car.)" value={newAdminPwd} onChange={e=>setNewAdminPwd(e.target.value)}
            style={{width:'100%',background:'#0d1117',border:'1px solid #1a2030',borderRadius:5,color:'#c0c8d8',fontSize:11,padding:'7px 10px',outline:'none',boxSizing:'border-box',marginBottom:6}}/>
          <input type="password" placeholder="Confirmer le mot de passe" value={confirmAdminPwd} onChange={e=>setConfirmAdminPwd(e.target.value)}
            style={{width:'100%',background:'#0d1117',border:'1px solid #1a2030',borderRadius:5,color:'#c0c8d8',fontSize:11,padding:'7px 10px',outline:'none',boxSizing:'border-box',marginBottom:6}}/>
          <button onClick={changeAdminPassword} style={{width:'100%',padding:'7px',borderRadius:5,background:'rgba(124,77,255,0.12)',border:'1px solid #7c4dff44',color:'#7c4dff',fontSize:11,fontWeight:700,cursor:'pointer'}}>
            Changer le mot de passe
          </button>
          {adminPwdMsg && <div style={{fontSize:10,marginTop:6,color:adminPwdMsg.startsWith('✅')?'#00e5cc':'#ff6b6b'}}>{adminPwdMsg}</div>}
        </div>

        {/* Section vider historique */}
        <div style={{padding:'10px 20px',borderBottom:'1px solid #1a2030',flexShrink:0,background:'#090c12'}}>
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',cursor:'pointer'}} onClick={()=>setShowTradesSection(v=>!v)}>
            <div style={{display:'flex',alignItems:'center',gap:8}}>
              <span style={{fontSize:12}}>🗑</span>
              <span style={{fontSize:11,fontWeight:700,color:'#5a6a80',letterSpacing:'0.5px'}}>HISTORIQUE SIMULATION</span>
            </div>
            <span style={{fontSize:10,color:'#3a4a5a'}}>{showTradesSection ? '▲' : '▼'}</span>
          </div>
          {showTradesSection && (
            <div style={{marginTop:12,display:'flex',flexDirection:'column',gap:8}}>
              {confirmClear ? (
                <div style={{display:'flex',flexDirection:'column',gap:6}}>
                  <div style={{fontSize:11,color:'#ff6b6b',fontWeight:700}}>Confirmer la suppression ?</div>
                  <div style={{display:'flex',gap:6}}>
                    <button onClick={()=>clearSimTrades(confirmClear)} style={{flex:1,padding:'6px 10px',borderRadius:6,background:'rgba(255,107,107,0.15)',border:'1px solid #ff6b6b44',color:'#ff6b6b',fontSize:11,fontWeight:700,cursor:'pointer'}}>Oui, supprimer</button>
                    <button onClick={()=>setConfirmClear('')} style={{flex:1,padding:'6px 10px',borderRadius:6,background:'#0d1117',border:'1px solid #1a2030',color:'#5a6a80',fontSize:11,cursor:'pointer'}}>Annuler</button>
                  </div>
                </div>
              ) : (
                <div style={{display:'flex',gap:6}}>
                  <button onClick={()=>setConfirmClear('history')} style={{flex:1,padding:'6px 10px',borderRadius:6,background:'rgba(255,107,107,0.08)',border:'1px solid #ff6b6b22',color:'#ff6b6b',fontSize:11,fontWeight:700,cursor:'pointer'}}>Vider historique</button>
                  <button onClick={()=>setConfirmClear('all')} style={{flex:1,padding:'6px 10px',borderRadius:6,background:'rgba(255,107,107,0.15)',border:'1px solid #ff6b6b44',color:'#ff6b6b',fontSize:11,fontWeight:700,cursor:'pointer'}}>Tout effacer (SIM)</button>
                </div>
              )}
              {tradesMsg && <div style={{fontSize:10,color:tradesMsg.startsWith('✅')?'#00e5cc':'#ff6b6b'}}>{tradesMsg}</div>}
              <div style={{fontSize:9,color:'#3a4a5a'}}>"Vider historique" = trades terminés uniquement · "Tout effacer" = positions ouvertes aussi</div>
            </div>
          )}
        </div>

        <div style={{display:'flex',gap:6,padding:'12px 20px',borderBottom:'1px solid #1a2030',flexShrink:0}}>
          {[['pending','🟡 En attente'],['approved','✅ Approuvés'],['expired','⏰ Expirés'],['all','Tous']].map(([v,l])=>(
            <button key={v} onClick={()=>setFilter(v)}
              style={{padding:'5px 12px',borderRadius:6,background:filter===v?'rgba(0,229,204,0.15)':'#0d1117',border:`1px solid ${filter===v?'#00e5cc44':'#1a2030'}`,color:filter===v?'#00e5cc':'#5a6a80',fontSize:11,fontWeight:700,cursor:'pointer'}}>
              {l}
            </button>
          ))}
        </div>

        <div style={{flex:1,overflowY:'auto',padding:'12px 20px'}}>
          {loading ? (
            <div style={{textAlign:'center',color:'#3a4a5a',padding:40}}>Chargement...</div>
          ) : users.length === 0 ? (
            <div style={{textAlign:'center',color:'#3a4a5a',padding:40}}>
              <div style={{fontSize:32,marginBottom:8}}></div>
              <div>Aucun utilisateur dans cette catégorie</div>
            </div>
          ) : users.map(u=>(
            <div key={u.id}>
              <div style={{padding:'12px 14px',borderRadius:8,background:'#0d1117',border:`1px solid ${selectedUser?.id===u.id?'#00e5cc33':'#1a2030'}`,marginBottom:8}}
                onClick={()=>setSelectedUser(selectedUser?.id===u.id?null:u)}>
                <div style={{display:'flex',alignItems:'center',gap:12}}>
                  <div style={{width:36,height:36,borderRadius:'50%',background:'rgba(0,229,204,0.1)',border:'1px solid #00e5cc22',display:'flex',alignItems:'center',justifyContent:'center',fontSize:14,color:'#00e5cc',flexShrink:0}}>
                    {u.email?.charAt(0).toUpperCase()}
                  </div>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:12,fontWeight:700,color:'#c0c8d8',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{u.email}</div>
                    <div style={{display:'flex',gap:6,marginTop:3,flexWrap:'wrap'}}>
                      <span style={{fontSize:9,padding:'1px 6px',borderRadius:4,background:u.approved?'rgba(0,229,204,0.12)':'rgba(255,193,7,0.12)',color:u.approved?'#00e5cc':'#ffc107',border:`1px solid ${u.approved?'#00e5cc22':'#ffc10722'}`,fontWeight:700}}>
                        {u.approved?'✅ Approuvé':u.pending?'🟡 En attente':'❌ Refusé'}
                      </span>
                      {u.plan && u.plan !== 'free'&& <span style={{fontSize:9,padding:'1px 6px',borderRadius:4,background:'rgba(124,77,255,0.12)',color:getPlanColor(u.plan),border:`1px solid ${getPlanColor(u.plan)}22`,fontWeight:700,textTransform:'uppercase'}}>{u.plan}</span>}
                      {u.plan_expires_at && <span style={{fontSize:9,padding:'1px 6px',borderRadius:4,background:isExpired(u)?'rgba(255,107,107,0.12)':'rgba(90,106,128,0.12)',color:isExpired(u)?'#ff6b6b':'#5a6a80',border:`1px solid ${isExpired(u)?'#ff6b6b22':'#5a6a8022'}`,fontWeight:700}}>{isExpired(u)?'EXPIRÉ':`${daysLeft(u)}j restants`}</span>}
                      {u.sim_balance && <span style={{fontSize:9,padding:'1px 6px',borderRadius:4,background:'rgba(124,77,255,0.12)',color:'#7c4dff',border:'1px solid #7c4dff22',fontWeight:700}}> {u.sim_balance} SOL</span>}
                      {u.is_admin && <span style={{fontSize:9,padding:'1px 6px',borderRadius:4,background:'rgba(124,77,255,0.12)',color:'#7c4dff',border:'1px solid #7c4dff22',fontWeight:700}}> ADMIN</span>}
                      <span style={{fontSize:9,color:'#3a4a5a'}}>{u.created_at?new Date(u.created_at).toLocaleDateString('fr-FR'):''}</span>
                    </div>
                  </div>
                  <div style={{display:'flex',gap:6,flexShrink:0}} onClick={e=>e.stopPropagation()}>
                    <button onClick={()=>setViewUser(u)}
                      style={{padding:'6px 10px',borderRadius:6,background:'rgba(0,229,204,0.1)',border:'1px solid #00e5cc22',color:'#00e5cc',fontSize:10,fontWeight:700,cursor:'pointer'}}>
                       Voir
                    </button>
                    {/*  Bouton impersonation */}
                    {onImpersonate && !u.is_admin && (
                      <button onClick={()=>onImpersonate(u)}
                        style={{padding:'6px 10px',borderRadius:6,background:'rgba(240,165,0,0.1)',border:'1px solid #f0a50033',color:'#f0a500',fontSize:10,fontWeight:700,cursor:'pointer'}}>
                        👁
                      </button>
                    )}
                    {!u.is_admin&&!u.approved&&u.pending&&(
                      <button onClick={()=>setSelectedUser(u)}
                        style={{padding:'6px 10px',borderRadius:6,background:'rgba(0,229,204,0.15)',border:'1px solid #00e5cc33',color:'#00e5cc',fontSize:10,fontWeight:700,cursor:'pointer'}}>
                        ✅
                      </button>
                    )}
                    {!u.is_admin&&u.approved&&(
                      <button onClick={()=>revoke(u.id)}
                        style={{padding:'6px 10px',borderRadius:6,background:'rgba(255,107,107,0.1)',border:'1px solid #ff6b6b33',color:'#ff6b6b',fontSize:10,fontWeight:700,cursor:'pointer'}}>
                        ❌
                      </button>
                    )}
                    {!u.is_admin&&!u.approved&&u.pending&&(
                      <button onClick={()=>reject(u.id)}
                        style={{padding:'6px 10px',borderRadius:6,background:'rgba(255,107,107,0.1)',border:'1px solid #ff6b6b33',color:'#ff6b6b',fontSize:10,fontWeight:700,cursor:'pointer'}}>
                        ❌
                      </button>
                    )}
                    {!u.is_admin&&!u.approved&&!u.pending&&(
                      <button onClick={()=>setSelectedUser(u)}
                        style={{padding:'6px 10px',borderRadius:6,background:'rgba(0,229,204,0.1)',border:'1px solid #00e5cc33',color:'#00e5cc',fontSize:10,fontWeight:700,cursor:'pointer'}}>
                        Réactiver
                      </button>
                    )}
                  </div>
                </div>
              </div>

              {selectedUser?.id === u.id && !u.is_admin && (
                <div style={{margin:'-4px 0 8px 0',padding:'16px',background:'rgba(0,229,204,0.03)',border:'1px solid #00e5cc22',borderRadius:'0 0 8px 8px'}}>
                  <div style={{fontSize:11,fontWeight:700,color:'#00e5cc',marginBottom:12}}> Configuration de l'accès</div>
                  <div style={{marginBottom:12}}>
                    <div style={{fontSize:10,color:'#5a6a80',marginBottom:6,letterSpacing:'0.8px'}}> SOLDE SIM (SOL)</div>
                    <div style={{display:'flex',gap:6,marginBottom:6,flexWrap:'wrap'}}>
                      {['10','50','100','500','1000'].map(v=>(
                        <button key={v} onClick={()=>setSimInput(v)}
                          style={{padding:'4px 10px',borderRadius:4,background:simInput===v?'rgba(124,77,255,0.2)':'#0d1117',border:`1px solid ${simInput===v?'#7c4dff44':'#1a2030'}`,color:simInput===v?'#7c4dff':'#5a6a80',fontSize:10,fontWeight:700,cursor:'pointer'}}>
                          {v}
                        </button>
                      ))}
                      <input type="number"placeholder="Personnalisé..."value={simInput} onChange={e=>setSimInput(e.target.value)}
                        style={{background:'#0d1117',border:'1px solid #1a2030',borderRadius:4,color:'#c0c8d8',fontSize:10,padding:'4px 8px',outline:'none',width:100}}/>
                    </div>
                  </div>
                  <div style={{marginBottom:12}}>
                    <div style={{fontSize:10,color:'#5a6a80',marginBottom:6,letterSpacing:'0.8px'}}> PLAN</div>
                    <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                      {plans.map(p=>(
                        <button key={p} onClick={()=>setPlanInput(p)}
                          style={{padding:'4px 10px',borderRadius:4,background:planInput===p?'rgba(0,229,204,0.15)':'#0d1117',border:`1px solid ${planInput===p?'#00e5cc44':'#1a2030'}`,color:planInput===p?'#00e5cc':'#5a6a80',fontSize:10,fontWeight:700,cursor:'pointer',textTransform:'uppercase'}}>
                          {p}
                        </button>
                      ))}
                    </div>
                  </div>
                  {planInput !== 'lifetime'&& (
                    <div style={{marginBottom:16}}>
                      <div style={{fontSize:10,color:'#5a6a80',marginBottom:6,letterSpacing:'0.8px'}}> DURÉE</div>
                      <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                        {durations.map(([v,l])=>(
                          <button key={v} onClick={()=>setDurationInput(v)}
                            style={{padding:'4px 10px',borderRadius:4,background:durationInput===v?'rgba(0,229,204,0.15)':'#0d1117',border:`1px solid ${durationInput===v?'#00e5cc44':'#1a2030'}`,color:durationInput===v?'#00e5cc':'#5a6a80',fontSize:10,fontWeight:700,cursor:'pointer'}}>
                            {l}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                  <div style={{display:'flex',gap:8}}>
                    <button onClick={()=>setSelectedUser(null)}
                      style={{flex:1,padding:'8px',borderRadius:6,background:'#0d1117',border:'1px solid #1a2030',color:'#5a6a80',fontSize:11,fontWeight:700,cursor:'pointer'}}>
                      Annuler
                    </button>
                    {!u.approved && (
                      <button onClick={()=>approve(u)}
                        style={{flex:2,padding:'8px',borderRadius:6,background:'rgba(0,229,204,0.15)',border:'1px solid #00e5cc33',color:'#00e5cc',fontSize:11,fontWeight:700,cursor:'pointer'}}>
                         Approuver
                      </button>
                    )}
                    {u.approved && (
                      <button onClick={()=>renew(u)}
                        style={{flex:2,padding:'8px',borderRadius:6,background:'rgba(124,77,255,0.15)',border:'1px solid #7c4dff33',color:'#7c4dff',fontSize:11,fontWeight:700,cursor:'pointer'}}>
                         Renouveler
                      </button>
                    )}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div style={{padding:'12px 20px',borderTop:'1px solid #1a2030',fontSize:10,color:'#3a4a5a',textAlign:'center',flexShrink:0}}>
          {users.length} utilisateur(s) · Clique sur  pour voir les détails ·  pour voir son interface
        </div>
      </div>
    </div>
  );
}